<div class="card card-w-title">
  <div class="page-header">
    <h1>View Route Access</h1>
    <!--<p>Some description</p>-->
  </div>
  <div class="ui-g">
    <div class="ui-g-12">
      <p-table
        #dt
        [value]="routes"
        [responsive]="true"
        scrollable="true"
        [loading]="isBusy"
        [paginator]="true"
        [rows]="10"
        [rowsPerPageOptions]="[5, 10, 20]"
        [pageLinks]="5"
      >
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="path">Path</th>
            <th pSortableColumn="title">Title</th>
            <th pSortableColumn="roles">Roles</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <tr [pSelectableRow]="item">
            <td>{{ item.path }}</td>
            <td>
              <span>{{ item.title || '-' }}</span>
            </td>
            <td>
              <p-dropdown
                appendTo="body"
                [options]="roles"
                [style]="{ width: '100%' }"
                styleClass="ui-column-filter"
                (onChange)="dt.filter($event.value, item.roles, item.filterMatchMode)"
              ></p-dropdown>
            </td>
          </tr>
        </ng-template>
      </p-table>

      <!-- DATATABLES DEPRECATED ---
            <p-dataTabl #dt [value]="routes"
                         [responsive]="true"
                         scrollable="true"
                         [loading]="isBusy"
                         [paginator]="true" [rows]="10" [rowsPerPageOptions]="[5,10,20]" [pageLinks]="5" >
                <p-header>List of Routes</p-header>
                <p-column header="Path" field="path"  filter="true" sortable="tru" filterMatchMode="contains" ></p-column>
                <p-column header="Title" field="title"  filter="true" sortable="tru" filterMatchMode="contains" >
                    <ng-template let-route="rowData" pTemplate="body">
                        <span>{{route.title || '-'}}</span>
                    </ng-template>
                </p-column>
                <p-column header="Roles" field="roles" filter="true" sortable="tru" filterMatchMode="contains">
                    <ng-template let-col pTemplate="filter">
                        <p-dropdown appendTo="body" [options]="roles" [style]="{'width': '100%'}" styleClass="ui-column-filter"
                                    (onChange)="dt.filter($event.value,col.field,col.filterMatchMode)"></p-dropdown>
                    </ng-template>
                </p-column>
            </p-dataTable>
            -->
    </div>
  </div>
</div>
